import { render, staticRenderFns } from "./LeadStatusInput.vue?vue&type=template&id=f72c4d8a&"
import script from "./LeadStatusInput.vue?vue&type=script&lang=js&"
export * from "./LeadStatusInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports